module.exports = __webpack_public_path__ + "img/盐山管道.8d8ad3e6.jpg";